import { createRoute } from '@tanstack/react-router'
import rootRoute from '../rootRoute'
import AdminTabs from './AdminTabs'
import ProfilesList from '@/components/admin/ProfilesList'
import { adminRouteLoader } from '@/lib/auth'
import { spacing } from '@/components/ui'

function AdminProfilingView() {
  return (
    <div
      style={{
        maxWidth: 'var(--container-max)',
        margin: '0 auto',
        padding: 'var(--space-8) var(--gutter) var(--space-20)',
      }}
    >
      <AdminTabs />
      <div className="oumma-overline" style={{ marginBottom: spacing.sm }}>
        Espace admin
      </div>
      <h1 style={{ fontSize: 'var(--text-h1)', margin: '0 0 28px' }}>
        Profiling
      </h1>
      <ProfilesList />
    </div>
  )
}

export const adminProfilingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/admin/profiling',
  loader: adminRouteLoader,
}).lazy(() => import('./AdminProfilingView.lazy').then((m) => m.Route))

export default AdminProfilingView
